function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M156.655 65.8604L161.548 169.161H221.515L226.409 65.8604H156.655Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M156.655 61.6104L159.642 164.911H196.251L199.238 61.6104H156.655Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M152.048 52.4546C151.983 51.3599 152.853 50.4365 153.95 50.4365H229.979C231.075 50.4365 231.945 51.3599 231.88 52.4546L231.075 66.0226C231.045 66.5259 230.628 66.9187 230.124 66.9187H153.805C153.3 66.9187 152.884 66.5259 152.854 66.0226L152.048 52.4546Z",
  fill: "#0FC3FC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M226.409 62.1113L157.52 62.1113L158.289 42.6856C158.33 41.6636 159.17 40.8559 160.193 40.8559L223.736 40.8559C224.758 40.8559 225.599 41.6636 225.639 42.6856L226.409 62.1113Z",
  fill: "#0FC3FC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0537 19.0732C36.0537 9.36778 43.9215 1.5 53.6269 1.5C63.3323 1.5 71.2001 9.36778 71.2001 19.0732V60.6111H36.0537V19.0732Z",
  stroke: "#CEF3FF",
  strokeWidth: 3
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6953 19.0732C50.6953 9.36778 58.5631 1.5 68.2685 1.5C77.9739 1.5 85.8417 9.36778 85.8417 19.0732V60.6111H50.6953V19.0732Z",
  stroke: "#92E5FF",
  strokeWidth: 3
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M104.6 49.8243L110.012 54.4238L115.53 49.7354H115.997V164.233H17.4243V49.7354H17.8924L23.4097 54.4238L28.8223 49.8243L34.235 54.4238L39.6476 49.8243L45.0603 54.4238L50.473 49.8243L55.8856 54.4238L61.2983 49.8243L66.7109 54.4238L72.1236 49.8243L77.5363 54.4238L82.9489 49.8243L88.3616 54.4238L93.7742 49.8243L99.1869 54.4238L104.6 49.8243Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M87.1281 86.6523C85.7004 86.6523 84.3358 87.2583 83.4439 88.3531C74.5376 99.2865 69.2119 113.155 69.2119 128.246H199.363C199.363 113.155 194.037 99.2865 185.131 88.3531C184.239 87.2583 182.874 86.6523 181.447 86.6523H87.1281Z",
  fill: "#FAF5FF"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 59.7554,
  y: 107.449,
  width: 149.064,
  height: 6.67625,
  fill: "#0FC3FC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.063 170C83.3023 160.129 66.913 138.684 64.6289 113.261H203.947C201.663 138.684 185.273 160.129 162.513 170H106.063Z",
  fill: "#0080DC"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.0702,
  cy: 93.3784,
  rx: 21.1254,
  ry: 20.7466,
  fill: "#0FC3FC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M127.311 86.6523C130.439 94.2674 138.036 99.6414 146.91 99.6414C155.785 99.6414 163.381 94.2674 166.509 86.6523H127.311Z",
  fill: "#0FC3FC"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.0702,
  cy: 93.3784,
  rx: 21.1254,
  ry: 20.7466,
  fill: "#0FC3FC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M0 50.2002V164.698H17.4245V50.2002L13.0684 54.0636L8.71227 50.2002L4.35613 54.0636L0 50.2002Z",
  fill: "#92E5FF"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 75.4502V111.25C11.2193 107.656 7 100.986 7 93.3502C7 85.7148 11.2193 79.0441 17.5 75.4502Z",
  fill: "#0080DC"
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 123.731,
  y1: 61.6104,
  x2: 199.238,
  y2: 61.6104,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#442BA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#442BA4",
  stopOpacity: 0
})));

function SvgShopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 170,
    viewBox: "0 0 232 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/Shopping.6d649692.svg";
export { ForwardRef as ReactComponent };